Application.Postcard.Icon.Greeting = {
    ui: {
        container: '.js-signature-greeting',
        text: '.js-signature-greeting__text-input',
        hidden: '.js-signature-greeting__hidden-input',
        submit: '.js-signature-greeting__submit',
        previewContainer: '.js-signature-greeting__preview-content',
        previewText: '.js-signature-greeting__preview-name'
    },
    autoSubmit: false,
    ready: function (previewList) {

        if (!$(this.ui.container).length){
            return;
        }

        // assign
        this.previewList = previewList;

        // autosubmit, if no button exists
        if (!$(this.ui.submit).length){
            this.autoSubmit = true;
        }

        // bind handlers
        this.bind();
        // init
        this.change($(this.ui.text).val());

    },
    bind: function(){

        var self = this;

        $(document).on('click', this.ui.submit, function(event){
            event.preventDefault();
            self.change($(self.ui.text).val());
        });
        $(document).on('keyup', this.ui.text, function(event){
            if (event.which === 13 /* Enter */){
                event.preventDefault();
            }
            if (self.autoSubmit){
                self.change($(self.ui.text).val());
            }
        });

    },
    change: function(name){

        var self = this;

        $(this.ui.hidden).val(name);
        $(this.ui.previewText).text(name);
        $(this.ui.previewContainer).attr('data-length', name.length);

        // recalculate DOM and reset icon size
        setTimeout(function(){
            self.previewList.reset();
        }, 0);

    }
}